export const ANDROID_VERSION_MAP = {
  PELATIHAN_MANDIRI_NATIVE: 13300,
}
